// extracted by mini-css-extract-plugin
export default {"header":"CompanySelectionPanel_header__1v4p4","wrapper":"CompanySelectionPanel_wrapper__owM4M"};